import React from 'react';
import {Outlet} from 'react-router-dom';
import Header from "../../sections/default/header";
import Footer from "../../sections/default/footer";

const Layout = (props) => {

    return (
        <div className="flex flex-col min-h-screen bg-[#faf8f5]">

           <Header />

           <main>
               <Outlet />
               {props.child}
           </main>

            <Footer />
        </div>
    );
};

export default Layout;